<template>
    <v-footer
        dark
        height="auto"
    >

        <v-card
            flat
            color="secondary"
            width="100%"
        >
            <v-card-text>
                <v-layout wrap>
                    <v-flex xs12 md4>
                        <div class="subheading">{{organizer.name}}</div>
                        <div class="body-2">{{organizer.street}} {{organizer.street_suffix}}</div>
                        <div class="body-2">{{organizer.postcode}} {{organizer.city}}</div>
                    </v-flex>
                    <v-flex xs12 md4>
                        <div class="subheading">Kontakt</div>
                        <div class="body-2">
                            <v-icon small class="mr-2">phone</v-icon>
                            {{organizer.phone}}
                        </div>
                        <div class="body-2">
                            <v-icon small class="mr-2">email</v-icon>
                            <a class="white--text" :href="'mailto:'+organizer.email">{{organizer.email}}</a></div>
                    </v-flex>
                    <v-flex xs12 md4>
                        <div class="subheading">Werden Sie jetzt Mitglied!</div>
                        <div class="body-2"><a class="white--text" href="https://www.marburger-bund.de/vorteile">5
                            Vorteile einer Mitgliedschaft</a></div>
                        <div class="body-2"><a class="white--text"
                                               href="https://www.marburger-bund.de/bundesverband/themen/studium/deine-vorteile-im-studium">Kostenlos
                            für Studenten</a></div>
                    </v-flex>
                </v-layout>
            </v-card-text>

            <v-card-actions class="primary">
                <v-layout wrap>
                    <v-flex shrink>
                        &copy;2019 {{organizer.name}}
                    </v-flex>
                    <v-spacer></v-spacer>
                    <v-flex shrink>
                        <a class="white--text" @click.prevent.stop="$store.commit('setLegalNotice', true)">Impressum</a> |
                        <a class="white--text" @click.prevent.stop="$store.commit('setPrivacyPolicy', true)">Datenschutz</a> |
                        <a class="white--text" @click.prevent.stop="$store.commit('setTerms', true)">AGB</a>
                        <s-legal-notice :organizer="organizer" style="display: inline-block"></s-legal-notice>
                        <s-privacy-policy :organizer="organizer" style="display: inline-block"></s-privacy-policy>
                        <s-terms :organizer="organizer" style="display: inline-block"></s-terms>
                    </v-flex>
                </v-layout>
            </v-card-actions>
        </v-card>
    </v-footer>
</template>

<script>
    export default {
        name: "Footer",
        props: {
            organizer: Object
        },
    }
</script>

<style scoped>

</style>
